(function() {
    'use strict';
    angular
        .module('functional7App')
        .factory('Licencia', Licencia);

    Licencia.$inject = ['$resource', 'DateUtils'];

    function Licencia ($resource, DateUtils) {
        var resourceUrl =  'api/licencias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaAlta = DateUtils.convertLocalDateFromServer(data.fechaAlta);
                        data.fechaCaducidad = DateUtils.convertLocalDateFromServer(data.fechaCaducidad);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fechaAlta = DateUtils.convertLocalDateToServer(copy.fechaAlta);
                    copy.fechaCaducidad = DateUtils.convertLocalDateToServer(copy.fechaCaducidad);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fechaAlta = DateUtils.convertLocalDateToServer(copy.fechaAlta);
                    copy.fechaCaducidad = DateUtils.convertLocalDateToServer(copy.fechaCaducidad);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
